import React from "react";

import { MotionPhotosAuto } from "@mui/icons-material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";

import { accessByTariffs } from "../../accessByTariffs";

import autofeedbacksSection from "./sections/autofeedbacks";
import calculatorSection from "./sections/calculator";
import competitorAnalysisSections from "./sections/competitorAnalysis";
import externalAnalysisSection from "./sections/externalAnalysis";
import growthLeadersSection from "./sections/growthLeaders";
import internalAnalyticsSection from "./sections/internalAnalytics";
import monitoringSection from "./sections/monitoring";
import nichesAndTrendsSection from "./sections/nichesAndTrends";
import promotionSection from "./sections/promotion";
import salesAnalyticsSection from "./sections/salesAnalytics";
import seoSection from "./sections/seo";

import ChromeIcon from "root/icons/Chrome";
import HunterTelegramIcon from "root/icons/HunterTelegram";
import LinkToWBIcon from "root/icons/LinkToWB";
import LogOutIcon from "root/icons/LogOut";
import Partner from "root/icons/Partner";
import YouTubeIcon from "root/icons/YouTube";

//
// Свойства для фильтрации
// onlyInDev - страница доступна только в компилируемой версии (дев01 и дев03 уже собранные)
// onlyForAdmin - страница доступна только админам
// noProd - страница доступна везде кроме продакшн версии
//
// -----------------------------------------------------------
const drawerPages = [
  competitorAnalysisSections, // "Анализ конкурентов"
  calculatorSection, // "Калькулятор" (WB / Ozon) — вторая секция
  // {
  //   type: "sectionItem",
  //   title: "AI Фото",
  //   icon: MotionPhotosAuto,
  //   url: "/ai_photo",
  //   component: React.lazy(() => import("root/pages/ai_photo/App")), // NEW
  //   noProd: true,
  // },
  growthLeadersSection,
  nichesAndTrendsSection,
  externalAnalysisSection,
  promotionSection,
  seoSection,
  monitoringSection,
  // salesAnalyticsWBSection,
  salesAnalyticsSection,
  autofeedbacksSection,
  internalAnalyticsSection,
  {
    type: "sectionItem",
    title: "Подключения",
    icon: LinkToWBIcon,
    url: "/wb-cabinets",
    component: React.lazy(() => import("root/pages/connections/App")),
    exact: false,
  },
  {
    type: "sectionItem",
    title: "Подключения",
    icon: LinkToWBIcon,
    // url: "/wb-cabinets",
    url: "/mp-cabinets", // позже нужно заменить на дефолтный путь, тк там настроена переадресация с вб
    component: React.lazy(() => import("root/pages/mp_cabinets/App")), // NEW
    noProd: true,
  },
  // {
  //   type: "sectionItem",
  //   title: "Браузерное расширение",
  //   icon: ChromeIcon,
  //   url: "/cabinet?tab=2",
  //   component: React.lazy(() => import("root/pages/cabinet/App")),
  //   exact: false,
  // },

  {
    type: "sectionItem",
    title: "Мой профиль",
    icon: AccountCircleOutlinedIcon,
    url: "/cabinet?tab=0",
    component: React.lazy(() => import("root/pages/cabinet/App")),
  },

  {
    type: "sectionItem",
    title: "Бонусы от партнеров",
    icon: Partner,
    url: "/partners-bonus",
    component: React.lazy(() => import("root/pages/partners-bonus/App")),
    noProd: true,
  },
  {
    type: "sectionItem",
    title: "Полезные материалы",
    icon: YouTubeIcon,
    url: "/useful",
    component: React.lazy(() => import("root/pages/useful/App")),
  },
  {
    type: "sectionItem",
    title: "Выход",
    icon: LogOutIcon,
    url: "/logout",
    component: React.lazy(() => import("root/pages/sign/components/SignOut")),
    exact: false,
  },
  {
    type: "sectionItem",
    onlyInDev: true,
    title: "Иконки",
    icon: WidgetsOutlinedIcon,
    url: "/icons",
    component: React.lazy(() => import("root/icons/utils/preview")),
    exact: true,
  },
  {
    type: "sectionItem",
    noProd: true,
    title: "iFrames для расширения",
    icon: Partner,
    url: "/test-frames",
    component: React.lazy(() => import("root/pages/iframes")),
    exact: true,
  },
].map(item => {
  if (!item.children) return item;
  return {
    ...item,
    // title: getTitle(item),
    children: item.children
      // Фильтруем дочерние страницы, которые должны быть только на деве
      // .filter(child => isDev || !child.onlyInDev)
      .map(child => ({
        ...child,
        // Добавляем плашки new и beta для секций
        // title: getTitle(child),
        // Добавляем доступы по тарифам по страницам секций
        tariffIds: accessByTariffs[child.url],
      })),
  };
});

export default drawerPages;
